import React from 'react';
import { styled } from '@components-shared/src/stitches';
import { NextFutureImage } from '@components/main-components/image/NextFutureImage';

export const GoldenEgg = () => {
  return (
    <Container>
      <NextFutureImage
        src="/images/collectorShelf/GoldenEgg.png"
        alt="Golden Egg"
        width={285}
        height={285}
        style={{
          objectFit: 'contain',
        }}
      />
    </Container>
  );
};

const Container = styled('div', {
  display: 'flex',
  width: '100%',
  height: '100%',
});
